import React from 'react';
import PropTypes from 'prop-types';
import { CCard, CCardHeader, CCardBody, CButton } from '@coreui/react';

const StepCardHeader = ({ step, activeStep, setActiveStep, children, title, description, lastEditStep }) => {
    return (
        <CCard className={`${activeStep === step ? 'show' : 'hide'} mb-3`}>
            <CCardHeader>
                {(activeStep !== step) ? (
                    <div className="rule-step d-inline-flex justify-content-between w-100">
                        <h5 className="mb-0 inactive">Step {step}: {title}</h5>
                        <p className="mb-0 mr-auto ml-5">{description}</p>

                        {(lastEditStep + 1) >= step && (
                            <CButton className="btn-edit" onClick={() => setActiveStep(step)}>
                                Edit
                            </CButton>
                        )}
                    </div>
                ) : (
                    <div className="d-inline-flex w-100">
                        <h5 className="mb-0">Step {step}: {title}</h5>
                        <p className="mb-0 ml-5">{description}</p>
                    </div>
                )}
            </CCardHeader>

            {activeStep === step && <CCardBody>{children}</CCardBody>}
        </CCard>
    );
};

StepCardHeader.propTypes = {
    step: PropTypes.number.isRequired,
    activeStep: PropTypes.number.isRequired,
    setActiveStep: PropTypes.func.isRequired,
    children: PropTypes.node,
    title: PropTypes.string,
    description: PropTypes.string
};

export default StepCardHeader;
